import React, { type FC } from 'react';

import { Box } from '@atlaskit/primitives/compiled';

export const TableSection: FC<{
	as?: 'thead' | 'tbody' | 'tfoot';
	testId?: string;
	children?: React.ReactNode;
}> = ({ children, ...props }) => <Box {...props}>{children}</Box>;
